import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { seoDataType } from '@entities/Seo/module/types/seoSchema';
import { fetchGetSeoDataApiDto } from './api.dto';
import { seoMockData, seoMockDataAuto } from '@entities/Seo/module/services/mock-data';
import { AxiosResponse } from 'axios';
import { sendSentrySeoInfo } from '@entities/Seo/module/helpers/sendSentrySeoInfo';

export const fetchGetSeoData = createAsyncThunk<seoDataType, fetchGetSeoDataApiDto>('seo/fetchGetSeoData', async query => {
  try {
    const url = `/api/catalog/seo?regionId=${query.regionId}&page=${encodeURIComponent(query.slug.replaceAll('&', ':'))}`;
    const response = await MyAxios.get<fetchGetSeoDataApiDto, AxiosResponse<{ data: seoDataType }>>(url);
    const data: seoDataType = handleResponse(response);
    sendSentrySeoInfo(url, data);

    return data;
  } catch (error) {
    return handleError(error, query.slug.includes('auto') ? seoMockDataAuto : seoMockData);
  }
});
